import React, { createContext, useContext, useState, useEffect } from 'react';

const BREAKPOINT = 1440;

type Ctx = { collapsed: boolean; toggle: () => void };

const SidebarContext = createContext<Ctx | null>(null);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [collapsed, setCollapsed] = useState(window.innerWidth < BREAKPOINT);

  /* auto-collapse / expand on resize */
  useEffect(() => {
    const onResize = () => setCollapsed(window.innerWidth < BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <SidebarContext.Provider
      value={{ collapsed, toggle: () => setCollapsed((c) => !c) }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar must be inside <SidebarProvider>');
  return ctx;
};
